const getMeasureUnits = () =>
  fetch(app.config.api.measureUnitsURL).then((res) =>
    res.json().then(({measure_units: measureUnits}) => measureUnits)
  );

export default getMeasureUnits;
